import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { whatsappConfig } from '../../config/whatsapp';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const { phoneNumber, message } = whatsappConfig;
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  
  return (
    <a 
      href={whatsappUrl} 
      className="whatsapp-button" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp />
      <span className="whatsapp-tooltip">Chat with us!</span>
    </a>
  );
};

export default WhatsAppButton;
